"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var CopyOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M789.333 320a128 128 0 01127.915 123.2l.085 4.8v341.333a128 128 0 01-123.2 127.915l-4.8.085H448a128 128 0 01-127.915-123.2l-.085-4.8V448a128 128 0 01123.2-127.915L448 320h341.333zm0 85.333H448a42.667 42.667 0 00-42.56 39.467l-.107 3.2v341.333a42.667 42.667 0 0039.467 42.56l3.2.107h341.333a42.667 42.667 0 0042.56-39.467l.107-3.2V448a42.667 42.667 0 00-39.467-42.56l-3.2-.107zm-192-298.666c57.024 0 104.128 43.925 106.56 99.754l.107 4.544v30.827a42.667 42.667 0 01-85.227 3.2l-.106-3.2v-30.827c0-9.386-7.936-17.706-18.774-18.837l-2.56-.128h-384a21.333 21.333 0 00-21.184 18.837l-.149 2.496V599.68c0 9.387 7.936 17.707 18.773 18.859l2.56.128h32a42.667 42.667 0 013.2 85.226l-3.2.107h-32c-57.024 0-104.128-43.925-106.56-99.755l-.106-4.544V213.333a106.667 106.667 0 01102.037-106.56l4.63-.106h384z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
CopyOutlined.displayName = "CopyOutlined";
var _default = exports["default"] = CopyOutlined;